/**
 * Copy for the homepage explainer-video section (VideoExplainerSection).
 *
 * Lives in the messaging bank so the hardcoded-copy guard
 * (scripts/qa/check-marketing-copy.sh) passes — every >40-char marketing
 * string on a landing surface must resolve from here, not inline JSX.
 */
export const VIDEO_EXPLAINER_COPY = {
  /** Catalog id rendered by the section. */
  videoId: 'homepage-explainer',
  heading: 'Watch Bri In Action',
  lede: 'A 1-minute walkthrough: Bri answers every call, text, and DM, qualifies the lead, and books every appointment — get setup in 60-seconds.',
  ctaLabel: 'Get started',
  ctaHref: '/auth/register',
} as const;
